// Derives the dealer's subdomain from the browser's current runtime hostname —
// distinct from clientApi.js's getSubdomain(), which is build-environment-based
// (REACT_APP_ENVIRONMENT) and used only to construct the API base URL. That one
// does not vary per dealer and must not be used for per-dealer telemetry tagging.
export const getDealerSubdomain = (): string => {
  const hostname = window.location.hostname;

  if (hostname.endsWith('.iserviceauto.com')) {
    return hostname.replace(/\.iserviceauto\.com$/, '').replace(/^www\./, '');
  }

  return hostname;
};
